// Utility function to test if localStorage is available

// Extracted from Modernizr
// https://github.com/Modernizr/Modernizr/blob/v3.11.2/feature-detects/storage/localstorage.js
/**
 * @param {Storage} storage
 * @return {boolean}
 */
export default function localStorageCheck(storage) {
  const mod = "local-storage-availability-test"
  try {
    storage.setItem(mod, mod)
    storage.getItem(mod)
    storage.removeItem(mod)
    return true
  } catch (e) {
    return false
  }
}
